import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_close",
  "use": "icon_close-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"icon_close\"><path fill=\"currentColor\" d=\"M40.032 6.576a1.968 1.968 0 00-2.783 0L23.97 19.854l-13.22-13.22a1.968 1.968 0 00-2.783 0L6.576 8.026a1.968 1.968 0 000 2.783l13.22 13.22L6.635 37.191a1.968 1.968 0 000 2.783l1.391 1.392a1.968 1.968 0 002.783 0l13.162-13.162 13.22 13.22a1.968 1.968 0 002.783 0l1.391-1.392a1.968 1.968 0 000-2.783l-13.22-13.22 13.279-13.278a1.968 1.968 0 000-2.783l-1.392-1.392z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol